export const countries = [
  {
    id: "af",
    code: { short: "af", long: "afg", numeric: "004" },
    name: "Afghanistan",
    currency: "afn",
    common: false,
  },
  {
    id: "ax",
    code: { short: "ax", long: "ala", numeric: "248" },
    name: "Åland Islands",
    currency: "eur",
    common: false,
  },
  {
    id: "al",
    code: { short: "al", long: "alb", numeric: "008" },
    name: "Albania",
    currency: "all",
    common: false,
  },
  {
    id: "dz",
    code: { short: "dz", long: "dza", numeric: "012" },
    name: "Algeria",
    currency: "dzd",
    common: false,
  },
  {
    id: "as",
    code: { short: "as", long: "asm", numeric: "016" },
    name: "American Samoa",
    currency: "usd",
    common: false,
  },
  {
    id: "ad",
    code: { short: "ad", long: "and", numeric: "020" },
    name: "Andorra",
    currency: "eur",
    common: false,
  },
  {
    id: "ao",
    code: { short: "ao", long: "ago", numeric: "024" },
    name: "Angola",
    currency: "aoa",
    common: false,
  },
  {
    id: "ai",
    code: { short: "ai", long: "aia", numeric: "660" },
    name: "Anguilla",
    currency: "xcd",
    common: false,
  },
  {
    id: "aq",
    code: { short: "aq", long: "ata", numeric: "010" },
    name: "Antarctica",
    currency: "usd",
    common: false,
  },
  {
    id: "ag",
    code: { short: "ag", long: "atg", numeric: "028" },
    name: "Antigua and Barbuda",
    currency: "xcd",
    common: false,
  },
  {
    id: "ar",
    code: { short: "ar", long: "arg", numeric: "032" },
    name: "Argentina",
    currency: "ars",
    common: false,
  },
  {
    id: "am",
    code: { short: "am", long: "arm", numeric: "051" },
    name: "Armenia",
    currency: "amd",
    common: false,
  },
  {
    id: "aw",
    code: { short: "aw", long: "abw", numeric: "533" },
    name: "Aruba",
    currency: "awg",
    common: false,
  },
  {
    id: "au",
    code: { short: "au", long: "aus", numeric: "036" },
    name: "Australia",
    currency: "aud",
    common: true,
  },
  {
    id: "at",
    code: { short: "at", long: "aut", numeric: "040" },
    name: "Austria",
    currency: "eur",
    common: true,
  },
  {
    id: "az",
    code: { short: "az", long: "aze", numeric: "031" },
    name: "Azerbaijan",
    currency: "azn",
    common: false,
  },
  {
    id: "bs",
    code: { short: "bs", long: "bhs", numeric: "044" },
    name: "Bahamas",
    currency: "bsd",
    common: false,
  },
  {
    id: "bh",
    code: { short: "bh", long: "bhr", numeric: "048" },
    name: "Bahrain",
    currency: "bhd",
    common: false,
  },
  {
    id: "bd",
    code: { short: "bd", long: "bgd", numeric: "050" },
    name: "Bangladesh",
    currency: "bdt",
    common: false,
  },
  {
    id: "bb",
    code: { short: "bb", long: "brb", numeric: "052" },
    name: "Barbados",
    currency: "bbd",
    common: false,
  },
  {
    id: "by",
    code: { short: "by", long: "blr", numeric: "112" },
    name: "Belarus",
    currency: "byn",
    common: false,
  },
  {
    id: "be",
    code: { short: "be", long: "bel", numeric: "056" },
    name: "Belgium",
    currency: "eur",
    common: true,
  },
  {
    id: "bz",
    code: { short: "bz", long: "blz", numeric: "084" },
    name: "Belize",
    currency: "bzd",
    common: false,
  },
  {
    id: "bj",
    code: { short: "bj", long: "ben", numeric: "204" },
    name: "Benin",
    currency: "xof",
    common: false,
  },
  {
    id: "bm",
    code: { short: "bm", long: "bmu", numeric: "060" },
    name: "Bermuda",
    currency: "bmd",
    common: false,
  },
  {
    id: "bt",
    code: { short: "bt", long: "btn", numeric: "064" },
    name: "Bhutan",
    currency: "inr",
    common: false,
  },
  {
    id: "bo",
    code: { short: "bo", long: "bol", numeric: "068" },
    name: "Bolivia",
    currency: "bob",
    common: false,
  },
  {
    id: "bq",
    code: { short: "bq", long: "bes", numeric: "535" },
    name: "Bonaire, Sint Eustatius and Saba",
    currency: "eur",
    common: false,
  },
  {
    id: "ba",
    code: { short: "ba", long: "bih", numeric: "070" },
    name: "Bosnia and Herzegovina",
    currency: "bam",
    common: false,
  },
  {
    id: "bw",
    code: { short: "bw", long: "bwa", numeric: "072" },
    name: "Botswana",
    currency: "bwp",
    common: false,
  },
  {
    id: "bv",
    code: { short: "bv", long: "bvt", numeric: "074" },
    name: "Bouvet Island",
    currency: "nok",
    common: false,
  },
  {
    id: "br",
    code: { short: "br", long: "bra", numeric: "076" },
    name: "Brazil",
    currency: "brl",
    common: true,
  },
  {
    id: "vg",
    code: { short: "vg", long: "vgb", numeric: "092" },
    name: "British Virgin Islands",
    currency: "usd",
    common: false,
  },
  {
    id: "io",
    code: { short: "io", long: "iot", numeric: "086" },
    name: "British Indian Ocean Territory",
    currency: "usd",
    common: false,
  },
  {
    id: "bn",
    code: { short: "bn", long: "brn", numeric: "096" },
    name: "Brunei Darussalam",
    currency: "bnd",
    common: false,
  },
  {
    id: "bg",
    code: { short: "bg", long: "bgr", numeric: "100" },
    name: "Bulgaria",
    currency: "bgn",
    common: false,
  },
  {
    id: "bf",
    code: { short: "bf", long: "bfa", numeric: "854" },
    name: "Burkina Faso",
    currency: "xof",
    common: false,
  },
  {
    id: "bi",
    code: { short: "bi", long: "bdi", numeric: "108" },
    name: "Burundi",
    currency: "bif",
    common: false,
  },
  {
    id: "kh",
    code: { short: "kh", long: "khm", numeric: "116" },
    name: "Cambodia",
    currency: "khr",
    common: false,
  },
  {
    id: "cm",
    code: { short: "cm", long: "cmr", numeric: "120" },
    name: "Cameroon",
    currency: "xaf",
    common: false,
  },
  {
    id: "ca",
    code: { short: "ca", long: "can", numeric: "124" },
    name: "Canada",
    currency: "cad",
    common: true,
  },
  {
    id: "cv",
    code: { short: "cv", long: "cpv", numeric: "132" },
    name: "Cape Verde",
    currency: "cve",
    common: false,
  },
  {
    id: "ky",
    code: { short: "ky", long: "cym", numeric: "136" },
    name: "Cayman Islands",
    currency: "kyd",
    common: false,
  },
  {
    id: "cf",
    code: { short: "cf", long: "caf", numeric: "140" },
    name: "Central African Republic",
    currency: "xaf",
    common: false,
  },
  {
    id: "td",
    code: { short: "td", long: "tcd", numeric: "148" },
    name: "Chad",
    currency: "xaf",
    common: false,
  },
  {
    id: "cl",
    code: { short: "cl", long: "chl", numeric: "152" },
    name: "Chile",
    currency: "clp",
    common: false,
  },
  {
    id: "cn",
    code: { short: "cn", long: "chn", numeric: "156" },
    name: "China",
    currency: "cny",
    common: true,
  },
  {
    id: "hk",
    code: { short: "hk", long: "hkg", numeric: "344" },
    name: "Hong Kong, SAR China",
    currency: "hkd",
    common: true,
  },
  {
    id: "mo",
    code: { short: "mo", long: "mac", numeric: "446" },
    name: "Macao, SAR China",
    currency: "mop",
    common: false,
  },
  {
    id: "cx",
    code: { short: "cx", long: "cxr", numeric: "162" },
    name: "Christmas Island",
    currency: "aud",
    common: false,
  },
  {
    id: "cc",
    code: { short: "cc", long: "cck", numeric: "166" },
    name: "Cocos (Keeling) Islands",
    currency: "aud",
    common: false,
  },
  {
    id: "co",
    code: { short: "co", long: "col", numeric: "170" },
    name: "Colombia",
    currency: "cop",
    common: true,
  },
  {
    id: "km",
    code: { short: "km", long: "com", numeric: "174" },
    name: "Comoros",
    currency: "kmf",
    common: false,
  },
  {
    id: "cg",
    code: { short: "cg", long: "cog", numeric: "178" },
    name: "Congo (Brazzaville)",
    currency: "xaf",
    common: false,
  },
  {
    id: "cd",
    code: { short: "cd", long: "cod", numeric: "180" },
    name: "Congo, (Kinshasa)",
    currency: "cdf",
    common: false,
  },
  {
    id: "ck",
    code: { short: "ck", long: "cok", numeric: "184" },
    name: "Cook Islands",
    currency: "nzd",
    common: false,
  },
  {
    id: "cr",
    code: { short: "cr", long: "cri", numeric: "188" },
    name: "Costa Rica",
    currency: "crc",
    common: false,
  },
  {
    id: "ci",
    code: { short: "ci", long: "civ", numeric: "384" },
    name: "Côte d'Ivoire",
    currency: "xof",
    common: false,
  },
  {
    id: "hr",
    code: { short: "hr", long: "hrv", numeric: "191" },
    name: "Croatia",
    currency: "hrk",
    common: false,
  },
  {
    id: "cu",
    code: { short: "cu", long: "cub", numeric: "192" },
    name: "Cuba",
    currency: "cup",
    common: false,
  },
  {
    id: "cw",
    code: { short: "cw", long: "cuw", numeric: "531" },
    name: "Curaçao",
    currency: "ang",
    common: false,
  },
  {
    id: "cy",
    code: { short: "cy", long: "cyp", numeric: "196" },
    name: "Cyprus",
    currency: "eur",
    common: false,
  },
  {
    id: "cz",
    code: { short: "cz", long: "cze", numeric: "203" },
    name: "Czech Republic",
    currency: "czk",
    common: false,
  },
  {
    id: "dk",
    code: { short: "dk", long: "dnk", numeric: "208" },
    name: "Denmark",
    currency: "dkk",
    common: false,
  },
  {
    id: "dj",
    code: { short: "dj", long: "dji", numeric: "262" },
    name: "Djibouti",
    currency: "djf",
    common: false,
  },
  {
    id: "dm",
    code: { short: "dm", long: "dma", numeric: "212" },
    name: "Dominica",
    currency: "xcd",
    common: false,
  },
  {
    id: "do",
    code: { short: "do", long: "dom", numeric: "214" },
    name: "Dominican Republic",
    currency: "dop",
    common: false,
  },
  {
    id: "ec",
    code: { short: "ec", long: "ecu", numeric: "218" },
    name: "Ecuador",
    currency: "usd",
    common: false,
  },
  {
    id: "eg",
    code: { short: "eg", long: "egy", numeric: "818" },
    name: "Egypt",
    currency: "egp",
    common: false,
  },
  {
    id: "sv",
    code: { short: "sv", long: "slv", numeric: "222" },
    name: "El Salvador",
    currency: "svc",
    common: false,
  },
  {
    id: "gq",
    code: { short: "gq", long: "gnq", numeric: "226" },
    name: "Equatorial Guinea",
    currency: "xaf",
    common: false,
  },
  {
    id: "er",
    code: { short: "er", long: "eri", numeric: "232" },
    name: "Eritrea",
    currency: "ern",
    common: false,
  },
  {
    id: "ee",
    code: { short: "ee", long: "est", numeric: "233" },
    name: "Estonia",
    currency: "eur",
    common: false,
  },
  {
    id: "et",
    code: { short: "et", long: "eth", numeric: "231" },
    name: "Ethiopia",
    currency: "etb",
    common: false,
  },
  {
    id: "fk",
    code: { short: "fk", long: "flk", numeric: "238" },
    name: "Falkland Islands (Malvinas)",
    currency: "fkp",
    common: false,
  },
  {
    id: "fo",
    code: { short: "fo", long: "fro", numeric: "234" },
    name: "Faroe Islands",
    currency: "dkk",
    common: false,
  },
  {
    id: "fj",
    code: { short: "fj", long: "fji", numeric: "242" },
    name: "Fiji",
    currency: "fjd",
    common: false,
  },
  {
    id: "fi",
    code: { short: "fi", long: "fin", numeric: "246" },
    name: "Finland",
    currency: "eur",
    common: false,
  },
  {
    id: "fr",
    code: { short: "fr", long: "fra", numeric: "250" },
    name: "France",
    currency: "eur",
    common: true,
  },
  {
    id: "gf",
    code: { short: "gf", long: "guf", numeric: "254" },
    name: "French Guiana",
    currency: "eur",
    common: false,
  },
  {
    id: "pf",
    code: { short: "pf", long: "pyf", numeric: "258" },
    name: "French Polynesia",
    currency: "xpf",
    common: false,
  },
  {
    id: "tf",
    code: { short: "tf", long: "atf", numeric: "260" },
    name: "French Southern Territories",
    currency: "eur",
    common: false,
  },
  {
    id: "ga",
    code: { short: "ga", long: "gab", numeric: "266" },
    name: "Gabon",
    currency: "xaf",
    common: false,
  },
  {
    id: "gm",
    code: { short: "gm", long: "gmb", numeric: "270" },
    name: "Gambia",
    currency: "gmd",
    common: false,
  },
  {
    id: "ge",
    code: { short: "ge", long: "geo", numeric: "268" },
    name: "Georgia",
    currency: "gel",
    common: false,
  },
  {
    id: "de",
    code: { short: "de", long: "deu", numeric: "276" },
    name: "Germany",
    currency: "eur",
    common: true,
  },
  {
    id: "gh",
    code: { short: "gh", long: "gha", numeric: "288" },
    name: "Ghana",
    currency: "ghs",
    common: false,
  },
  {
    id: "gi",
    code: { short: "gi", long: "gib", numeric: "292" },
    name: "Gibraltar",
    currency: "gip",
    common: false,
  },
  {
    id: "gr",
    code: { short: "gr", long: "grc", numeric: "300" },
    name: "Greece",
    currency: "eur",
    common: false,
  },
  {
    id: "gl",
    code: { short: "gl", long: "grl", numeric: "304" },
    name: "Greenland",
    currency: "dkk",
    common: false,
  },
  {
    id: "gd",
    code: { short: "gd", long: "grd", numeric: "308" },
    name: "Grenada",
    currency: "xcd",
    common: false,
  },
  {
    id: "gp",
    code: { short: "gp", long: "glp", numeric: "312" },
    name: "Guadeloupe",
    currency: "eur",
    common: false,
  },
  {
    id: "gu",
    code: { short: "gu", long: "gum", numeric: "316" },
    name: "Guam",
    currency: "usd",
    common: false,
  },
  {
    id: "gt",
    code: { short: "gt", long: "gtm", numeric: "320" },
    name: "Guatemala",
    currency: "gtq",
    common: false,
  },
  {
    id: "gg",
    code: { short: "gg", long: "ggy", numeric: "831" },
    name: "Guernsey",
    currency: "gbp",
    common: false,
  },
  {
    id: "gn",
    code: { short: "gn", long: "gin", numeric: "324" },
    name: "Guinea",
    currency: "gnf",
    common: false,
  },
  {
    id: "gw",
    code: { short: "gw", long: "gnb", numeric: "624" },
    name: "Guinea-Bissau",
    currency: "xof",
    common: false,
  },
  {
    id: "gy",
    code: { short: "gy", long: "guy", numeric: "328" },
    name: "Guyana",
    currency: "gyd",
    common: false,
  },
  {
    id: "ht",
    code: { short: "ht", long: "hti", numeric: "332" },
    name: "Haiti",
    currency: "htg",
    common: false,
  },
  {
    id: "hm",
    code: { short: "hm", long: "hmd", numeric: "334" },
    name: "Heard and Mcdonald Islands",
    currency: "aud",
    common: false,
  },
  {
    id: "va",
    code: { short: "va", long: "vat", numeric: "336" },
    name: "Holy See (Vatican City State)",
    currency: "eur",
    common: false,
  },
  {
    id: "hn",
    code: { short: "hn", long: "hnd", numeric: "340" },
    name: "Honduras",
    currency: "hnl",
    common: false,
  },
  {
    id: "hu",
    code: { short: "hu", long: "hun", numeric: "348" },
    name: "Hungary",
    currency: "huf",
    common: false,
  },
  {
    id: "is",
    code: { short: "is", long: "isl", numeric: "352" },
    name: "Iceland",
    currency: "isk",
    common: false,
  },
  {
    id: "in",
    code: { short: "in", long: "ind", numeric: "356" },
    name: "India",
    currency: "inr",
    common: true,
  },
  {
    id: "id",
    code: { short: "id", long: "idn", numeric: "360" },
    name: "Indonesia",
    currency: "idr",
    common: false,
  },
  {
    id: "ir",
    code: { short: "ir", long: "irn", numeric: "364" },
    name: "Iran, Islamic Republic of",
    currency: "irr",
    common: false,
  },
  {
    id: "iq",
    code: { short: "iq", long: "irq", numeric: "368" },
    name: "Iraq",
    currency: "iqd",
    common: false,
  },
  {
    id: "ie",
    code: { short: "ie", long: "irl", numeric: "372" },
    name: "Ireland",
    currency: "eur",
    common: true,
  },
  {
    id: "im",
    code: { short: "im", long: "imn", numeric: "833" },
    name: "Isle of Man",
    currency: "gbp",
    common: false,
  },
  {
    id: "il",
    code: { short: "il", long: "isr", numeric: "376" },
    name: "Israel",
    currency: "ils",
    common: false,
  },
  {
    id: "it",
    code: { short: "it", long: "ita", numeric: "380" },
    name: "Italy",
    currency: "eur",
    common: true,
  },
  {
    id: "jm",
    code: { short: "jm", long: "jam", numeric: "388" },
    name: "Jamaica",
    currency: "jmd",
    common: false,
  },
  {
    id: "jp",
    code: { short: "jp", long: "jpn", numeric: "392" },
    name: "Japan",
    currency: "jpy",
    common: true,
  },
  {
    id: "je",
    code: { short: "je", long: "jey", numeric: "832" },
    name: "Jersey",
    currency: "gbp",
    common: false,
  },
  {
    id: "jo",
    code: { short: "jo", long: "jor", numeric: "400" },
    name: "Jordan",
    currency: "jod",
    common: false,
  },
  {
    id: "kz",
    code: { short: "kz", long: "kaz", numeric: "398" },
    name: "Kazakhstan",
    currency: "kzt",
    common: false,
  },
  {
    id: "ke",
    code: { short: "ke", long: "ken", numeric: "404" },
    name: "Kenya",
    currency: "kes",
    common: false,
  },
  {
    id: "ki",
    code: { short: "ki", long: "kir", numeric: "296" },
    name: "Kiribati",
    currency: "aud",
    common: false,
  },
  {
    id: "kp",
    code: { short: "kp", long: "prk", numeric: "408" },
    name: "Korea (North)",
    currency: "kpw",
    common: false,
  },
  {
    id: "kr",
    code: { short: "kr", long: "kor", numeric: "410" },
    name: "Korea (South)",
    currency: "krw",
    common: false,
  },
  {
    id: "kw",
    code: { short: "kw", long: "kwt", numeric: "414" },
    name: "Kuwait",
    currency: "kwd",
    common: false,
  },
  {
    id: "kg",
    code: { short: "kg", long: "kgz", numeric: "417" },
    name: "Kyrgyzstan",
    currency: "kgs",
    common: false,
  },
  {
    id: "la",
    code: { short: "la", long: "lao", numeric: "418" },
    name: "Lao PDR",
    currency: "lak",
    common: false,
  },
  {
    id: "lv",
    code: { short: "lv", long: "lva", numeric: "428" },
    name: "Latvia",
    currency: "eur",
    common: false,
  },
  {
    id: "lb",
    code: { short: "lb", long: "lbn", numeric: "422" },
    name: "Lebanon",
    currency: "lbp",
    common: false,
  },
  {
    id: "ls",
    code: { short: "ls", long: "lso", numeric: "426" },
    name: "Lesotho",
    currency: "zar",
    common: false,
  },
  {
    id: "lr",
    code: { short: "lr", long: "lbr", numeric: "430" },
    name: "Liberia",
    currency: "lrd",
    common: false,
  },
  {
    id: "ly",
    code: { short: "ly", long: "lby", numeric: "434" },
    name: "Libya",
    currency: "lyd",
    common: false,
  },
  {
    id: "li",
    code: { short: "li", long: "lie", numeric: "438" },
    name: "Liechtenstein",
    currency: "chf",
    common: false,
  },
  {
    id: "lt",
    code: { short: "lt", long: "ltu", numeric: "440" },
    name: "Lithuania",
    currency: "eur",
    common: false,
  },
  {
    id: "lu",
    code: { short: "lu", long: "lux", numeric: "442" },
    name: "Luxembourg",
    currency: "eur",
    common: false,
  },
  {
    id: "mk",
    code: { short: "mk", long: "mkd", numeric: "807" },
    name: "Macedonia, Republic of",
    currency: "mkd",
    common: false,
  },
  {
    id: "mg",
    code: { short: "mg", long: "mdg", numeric: "450" },
    name: "Madagascar",
    currency: "mga",
    common: false,
  },
  {
    id: "mw",
    code: { short: "mw", long: "mwi", numeric: "454" },
    name: "Malawi",
    currency: "mwk",
    common: false,
  },
  {
    id: "my",
    code: { short: "my", long: "mys", numeric: "458" },
    name: "Malaysia",
    currency: "myr",
    common: false,
  },
  {
    id: "mv",
    code: { short: "mv", long: "mdv", numeric: "462" },
    name: "Maldives",
    currency: "mvr",
    common: false,
  },
  {
    id: "ml",
    code: { short: "ml", long: "mli", numeric: "466" },
    name: "Mali",
    currency: "xof",
    common: false,
  },
  {
    id: "mt",
    code: { short: "mt", long: "mlt", numeric: "470" },
    name: "Malta",
    currency: "eur",
    common: false,
  },
  {
    id: "mh",
    code: { short: "mh", long: "mhl", numeric: "584" },
    name: "Marshall Islands",
    currency: "usd",
    common: false,
  },
  {
    id: "mq",
    code: { short: "mq", long: "mtq", numeric: "474" },
    name: "Martinique",
    currency: "eur",
    common: false,
  },
  {
    id: "mr",
    code: { short: "mr", long: "mrt", numeric: "478" },
    name: "Mauritania",
    currency: "mru",
    common: false,
  },
  {
    id: "mu",
    code: { short: "mu", long: "mus", numeric: "480" },
    name: "Mauritius",
    currency: "mur",
    common: false,
  },
  {
    id: "yt",
    code: { short: "yt", long: "myt", numeric: "175" },
    name: "Mayotte",
    currency: "eur",
    common: false,
  },
  {
    id: "mx",
    code: { short: "mx", long: "mex", numeric: "484" },
    name: "Mexico",
    currency: "mxn",
    common: false,
  },
  {
    id: "fm",
    code: { short: "fm", long: "fsm", numeric: "583" },
    name: "Micronesia, Federated States of",
    currency: "usd",
    common: false,
  },
  {
    id: "md",
    code: { short: "md", long: "mda", numeric: "498" },
    name: "Moldova",
    currency: "mdl",
    common: false,
  },
  {
    id: "mc",
    code: { short: "mc", long: "mco", numeric: "492" },
    name: "Monaco",
    currency: "eur",
    common: false,
  },
  {
    id: "mn",
    code: { short: "mn", long: "mng", numeric: "496" },
    name: "Mongolia",
    currency: "mnt",
    common: false,
  },
  {
    id: "me",
    code: { short: "me", long: "mne", numeric: "499" },
    name: "Montenegro",
    currency: "eur",
    common: false,
  },
  {
    id: "ms",
    code: { short: "ms", long: "msr", numeric: "500" },
    name: "Montserrat",
    currency: "xcd",
    common: false,
  },
  {
    id: "ma",
    code: { short: "ma", long: "mar", numeric: "504" },
    name: "Morocco",
    currency: "mad",
    common: false,
  },
  {
    id: "mz",
    code: { short: "mz", long: "moz", numeric: "508" },
    name: "Mozambique",
    currency: "mzn",
    common: false,
  },
  {
    id: "mm",
    code: { short: "mm", long: "mmr", numeric: "104" },
    name: "Myanmar",
    currency: "mmk",
    common: false,
  },
  {
    id: "na",
    code: { short: "na", long: "nam", numeric: "516" },
    name: "Namibia",
    currency: "zar",
    common: false,
  },
  {
    id: "nr",
    code: { short: "nr", long: "nru", numeric: "520" },
    name: "Nauru",
    currency: "aud",
    common: false,
  },
  {
    id: "np",
    code: { short: "np", long: "npl", numeric: "524" },
    name: "Nepal",
    currency: "npr",
    common: false,
  },
  {
    id: "nl",
    code: { short: "nl", long: "nld", numeric: "528" },
    name: "Netherlands",
    currency: "eur",
    common: true,
  },
  {
    id: "nc",
    code: { short: "nc", long: "ncl", numeric: "540" },
    name: "New Caledonia",
    currency: "xpf",
    common: false,
  },
  {
    id: "nz",
    code: { short: "nz", long: "nzl", numeric: "554" },
    name: "New Zealand",
    currency: "nzd",
    common: false,
  },
  {
    id: "ni",
    code: { short: "ni", long: "nic", numeric: "558" },
    name: "Nicaragua",
    currency: "nio",
    common: false,
  },
  {
    id: "ne",
    code: { short: "ne", long: "ner", numeric: "562" },
    name: "Niger",
    currency: "xof",
    common: false,
  },
  {
    id: "ng",
    code: { short: "ng", long: "nga", numeric: "566" },
    name: "Nigeria",
    currency: "ngn",
    common: false,
  },
  {
    id: "nu",
    code: { short: "nu", long: "niu", numeric: "570" },
    name: "Niue",
    currency: "nzd",
    common: false,
  },
  {
    id: "nf",
    code: { short: "nf", long: "nfk", numeric: "574" },
    name: "Norfolk Island",
    currency: "aud",
    common: false,
  },
  {
    id: "mp",
    code: { short: "mp", long: "mnp", numeric: "580" },
    name: "Northern Mariana Islands",
    currency: "usd",
    common: false,
  },
  {
    id: "no",
    code: { short: "no", long: "nor", numeric: "578" },
    name: "Norway",
    currency: "nok",
    common: false,
  },
  {
    id: "om",
    code: { short: "om", long: "omn", numeric: "512" },
    name: "Oman",
    currency: "omr",
    common: false,
  },
  {
    id: "pk",
    code: { short: "pk", long: "pak", numeric: "586" },
    name: "Pakistan",
    currency: "pkr",
    common: false,
  },
  {
    id: "pw",
    code: { short: "pw", long: "plw", numeric: "585" },
    name: "Palau",
    currency: "usd",
    common: false,
  },
  {
    id: "ps",
    code: { short: "ps", long: "pse", numeric: "275" },
    name: "Palestinian Territory",
    currency: "ils",
    common: false,
  },
  {
    id: "pa",
    code: { short: "pa", long: "pan", numeric: "591" },
    name: "Panama",
    currency: "pab",
    common: false,
  },
  {
    id: "pg",
    code: { short: "pg", long: "png", numeric: "598" },
    name: "Papua New Guinea",
    currency: "pgk",
    common: false,
  },
  {
    id: "py",
    code: { short: "py", long: "pry", numeric: "600" },
    name: "Paraguay",
    currency: "pyg",
    common: false,
  },
  {
    id: "pe",
    code: { short: "pe", long: "per", numeric: "604" },
    name: "Peru",
    currency: "pen",
    common: false,
  },
  {
    id: "ph",
    code: { short: "ph", long: "phl", numeric: "608" },
    name: "Philippines",
    currency: "php",
    common: false,
  },
  {
    id: "pn",
    code: { short: "pn", long: "pcn", numeric: "612" },
    name: "Pitcairn",
    currency: "nzd",
    common: false,
  },
  {
    id: "pl",
    code: { short: "pl", long: "pol", numeric: "616" },
    name: "Poland",
    currency: "pln",
    common: false,
  },
  {
    id: "pt",
    code: { short: "pt", long: "prt", numeric: "620" },
    name: "Portugal",
    currency: "eur",
    common: false,
  },
  {
    id: "pr",
    code: { short: "pr", long: "pri", numeric: "630" },
    name: "Puerto Rico",
    currency: "usd",
    common: false,
  },
  {
    id: "qa",
    code: { short: "qa", long: "qat", numeric: "634" },
    name: "Qatar",
    currency: "qar",
    common: false,
  },
  {
    id: "re",
    code: { short: "re", long: "reu", numeric: "638" },
    name: "Réunion",
    currency: "eur",
    common: false,
  },
  {
    id: "ro",
    code: { short: "ro", long: "rou", numeric: "642" },
    name: "Romania",
    currency: "ron",
    common: false,
  },
  {
    id: "ru",
    code: { short: "ru", long: "rus", numeric: "643" },
    name: "Russia",
    currency: "rub",
    common: false,
  },
  {
    id: "rw",
    code: { short: "rw", long: "rwa", numeric: "646" },
    name: "Rwanda",
    currency: "rwf",
    common: false,
  },
  {
    id: "bl",
    code: { short: "bl", long: "blm", numeric: "652" },
    name: "Saint-Barthélemy",
    currency: "eur",
    common: false,
  },
  {
    id: "sh",
    code: { short: "sh", long: "shn", numeric: "654" },
    name: "Saint Helena",
    currency: "shp",
    common: false,
  },
  {
    id: "kn",
    code: { short: "kn", long: "kna", numeric: "659" },
    name: "Saint Kitts and Nevis",
    currency: "xcd",
    common: false,
  },
  {
    id: "lc",
    code: { short: "lc", long: "lca", numeric: "662" },
    name: "Saint Lucia",
    currency: "xcd",
    common: false,
  },
  {
    id: "mf",
    code: { short: "mf", long: "maf", numeric: "663" },
    name: "Saint-Martin (French part)",
    currency: "eur",
    common: false,
  },
  {
    id: "pm",
    code: { short: "pm", long: "spm", numeric: "666" },
    name: "Saint Pierre and Miquelon",
    currency: "eur",
    common: false,
  },
  {
    id: "vc",
    code: { short: "vc", long: "vct", numeric: "670" },
    name: "Saint Vincent and Grenadines",
    currency: "xcd",
    common: false,
  },
  {
    id: "ws",
    code: { short: "ws", long: "wsm", numeric: "882" },
    name: "Samoa",
    currency: "wst",
    common: false,
  },
  {
    id: "sm",
    code: { short: "sm", long: "smr", numeric: "674" },
    name: "San Marino",
    currency: "eur",
    common: false,
  },
  {
    id: "st",
    code: { short: "st", long: "stp", numeric: "678" },
    name: "Sao Tome and Principe",
    currency: "stn",
    common: false,
  },
  {
    id: "sa",
    code: { short: "sa", long: "sau", numeric: "682" },
    name: "Saudi Arabia",
    currency: "sar",
    common: false,
  },
  {
    id: "sn",
    code: { short: "sn", long: "sen", numeric: "686" },
    name: "Senegal",
    currency: "xof",
    common: false,
  },
  {
    id: "rs",
    code: { short: "rs", long: "srb", numeric: "688" },
    name: "Serbia",
    currency: "rsd",
    common: false,
  },
  {
    id: "sc",
    code: { short: "sc", long: "syc", numeric: "690" },
    name: "Seychelles",
    currency: "scr",
    common: false,
  },
  {
    id: "sl",
    code: { short: "sl", long: "sle", numeric: "694" },
    name: "Sierra Leone",
    currency: "sll",
    common: false,
  },
  {
    id: "sg",
    code: { short: "sg", long: "sgp", numeric: "702" },
    name: "Singapore",
    currency: "sgd",
    common: true,
  },
  {
    id: "sx",
    code: { short: "sx", long: "sxm", numeric: "534" },
    name: "Sint Maarten (Dutch part)",
    currency: "ang",
    common: false,
  },
  {
    id: "sk",
    code: { short: "sk", long: "svk", numeric: "703" },
    name: "Slovakia",
    currency: "eur",
    common: false,
  },
  {
    id: "si",
    code: { short: "si", long: "svn", numeric: "705" },
    name: "Slovenia",
    currency: "eur",
    common: false,
  },
  {
    id: "sb",
    code: { short: "sb", long: "slb", numeric: "090" },
    name: "Solomon Islands",
    currency: "sbd",
    common: false,
  },
  {
    id: "so",
    code: { short: "so", long: "som", numeric: "706" },
    name: "Somalia",
    currency: "sos",
    common: false,
  },
  {
    id: "za",
    code: { short: "za", long: "zaf", numeric: "710" },
    name: "South Africa",
    currency: "zar",
    common: true,
  },
  {
    id: "gs",
    code: { short: "gs", long: "sgs", numeric: "239" },
    name: "South Georgia and the South Sandwich Islands",
    currency: "gbp",
    common: false,
  },
  {
    id: "ss",
    code: { short: "ss", long: "ssd", numeric: "728" },
    name: "South Sudan",
    currency: "ssp",
    common: false,
  },
  {
    id: "es",
    code: { short: "es", long: "esp", numeric: "724" },
    name: "Spain",
    currency: "eur",
    common: true,
  },
  {
    id: "lk",
    code: { short: "lk", long: "lka", numeric: "144" },
    name: "Sri Lanka",
    currency: "lkr",
    common: false,
  },
  {
    id: "sd",
    code: { short: "sd", long: "sdn", numeric: "736" },
    name: "Sudan",
    currency: "sdg",
    common: false,
  },
  {
    id: "sr",
    code: { short: "sr", long: "sur", numeric: "740" },
    name: "Suriname",
    currency: "srd",
    common: false,
  },
  {
    id: "sj",
    code: { short: "sj", long: "sjm", numeric: "744" },
    name: "Svalbard and Jan Mayen Islands",
    currency: "nok",
    common: false,
  },
  {
    id: "sz",
    code: { short: "sz", long: "swz", numeric: "748" },
    name: "Swaziland",
    currency: "szl",
    common: false,
  },
  {
    id: "se",
    code: { short: "se", long: "swe", numeric: "752" },
    name: "Sweden",
    currency: "sek",
    common: false,
  },
  {
    id: "ch",
    code: { short: "ch", long: "che", numeric: "756" },
    name: "Switzerland",
    currency: "chf",
    common: true,
  },
  {
    id: "sy",
    code: { short: "sy", long: "syr", numeric: "760" },
    name: "Syrian Arab Republic (Syria)",
    currency: "syp",
    common: false,
  },
  {
    id: "tw",
    code: { short: "tw", long: "twn", numeric: "158" },
    name: "Taiwan, Republic of China",
    currency: "twd",
    common: false,
  },
  {
    id: "tj",
    code: { short: "tj", long: "tjk", numeric: "762" },
    name: "Tajikistan",
    currency: "tjs",
    common: false,
  },
  {
    id: "tz",
    code: { short: "tz", long: "tza", numeric: "834" },
    name: "Tanzania, United Republic of",
    currency: "tzs",
    common: false,
  },
  {
    id: "th",
    code: { short: "th", long: "tha", numeric: "764" },
    name: "Thailand",
    currency: "thb",
    common: false,
  },
  {
    id: "tl",
    code: { short: "tl", long: "tls", numeric: "626" },
    name: "Timor-Leste",
    currency: "usd",
    common: false,
  },
  {
    id: "tg",
    code: { short: "tg", long: "tgo", numeric: "768" },
    name: "Togo",
    currency: "xof",
    common: false,
  },
  {
    id: "tk",
    code: { short: "tk", long: "tkl", numeric: "772" },
    name: "Tokelau",
    currency: "nzd",
    common: false,
  },
  {
    id: "to",
    code: { short: "to", long: "ton", numeric: "776" },
    name: "Tonga",
    currency: "top",
    common: false,
  },
  {
    id: "tt",
    code: { short: "tt", long: "tto", numeric: "780" },
    name: "Trinidad and Tobago",
    currency: "ttd",
    common: false,
  },
  {
    id: "tn",
    code: { short: "tn", long: "tun", numeric: "788" },
    name: "Tunisia",
    currency: "tnd",
    common: false,
  },
  {
    id: "tr",
    code: { short: "tr", long: "tur", numeric: "792" },
    name: "Turkey",
    currency: "try",
    common: false,
  },
  {
    id: "tm",
    code: { short: "tm", long: "tkm", numeric: "795" },
    name: "Turkmenistan",
    currency: "tmt",
    common: false,
  },
  {
    id: "tc",
    code: { short: "tc", long: "tca", numeric: "796" },
    name: "Turks and Caicos Islands",
    currency: "usd",
    common: false,
  },
  {
    id: "tv",
    code: { short: "tv", long: "tuv", numeric: "798" },
    name: "Tuvalu",
    currency: "aud",
    common: false,
  },
  {
    id: "ug",
    code: { short: "ug", long: "uga", numeric: "800" },
    name: "Uganda",
    currency: "ugx",
    common: false,
  },
  {
    id: "ua",
    code: { short: "ua", long: "ukr", numeric: "804" },
    name: "Ukraine",
    currency: "uah",
    common: false,
  },
  {
    id: "ae",
    code: { short: "ae", long: "are", numeric: "784" },
    name: "United Arab Emirates",
    currency: "aed",
    common: false,
  },
  {
    id: "gb",
    code: { short: "gb", long: "gbr", numeric: "826" },
    name: "United Kingdom",
    currency: "gbp",
    common: true,
  },
  {
    id: "us",
    code: { short: "us", long: "usa", numeric: "840" },
    name: "United States",
    currency: "usd",
    common: true,
  },
  {
    id: "um",
    code: { short: "um", long: "umi", numeric: "581" },
    name: "US Minor Outlying Islands",
    currency: "usd",
    common: false,
  },
  {
    id: "uy",
    code: { short: "uy", long: "ury", numeric: "858" },
    name: "Uruguay",
    currency: "uyu",
    common: false,
  },
  {
    id: "uz",
    code: { short: "uz", long: "uzb", numeric: "860" },
    name: "Uzbekistan",
    currency: "uzs",
    common: false,
  },
  {
    id: "vu",
    code: { short: "vu", long: "vut", numeric: "548" },
    name: "Vanuatu",
    currency: "vuv",
    common: false,
  },
  {
    id: "ve",
    code: { short: "ve", long: "ven", numeric: "862" },
    name: "Venezuela (Bolivarian Republic)",
    currency: "vef",
    common: false,
  },
  {
    id: "vn",
    code: { short: "vn", long: "vnm", numeric: "704" },
    name: "Viet Nam",
    currency: "vnd",
    common: false,
  },
  {
    id: "vi",
    code: { short: "vi", long: "vir", numeric: "850" },
    name: "Virgin Islands, US",
    currency: "usd",
    common: false,
  },
  {
    id: "wf",
    code: { short: "wf", long: "wlf", numeric: "876" },
    name: "Wallis and Futuna Islands",
    currency: "xpf",
    common: false,
  },
  {
    id: "eh",
    code: { short: "eh", long: "esh", numeric: "732" },
    name: "Western Sahara",
    currency: "mad",
    common: false,
  },
  {
    id: "ye",
    code: { short: "ye", long: "yem", numeric: "887" },
    name: "Yemen",
    currency: "yer",
    common: false,
  },
  {
    id: "zm",
    code: { short: "zm", long: "zmb", numeric: "894" },
    name: "Zambia",
    currency: "zmw",
    common: false,
  },
  {
    id: "zw",
    code: { short: "zw", long: "zwe", numeric: "716" },
    name: "Zimbabwe",
    currency: "zwl",
    common: false,
  },
  {
    id: "ww",
    code: { short: "ww", long: "wwx", numeric: "999" },
    name: "Worldwide",
    currency: "usd",
    common: false,
  },
  {
    id: "e",
    code: { short: "e", long: "evt", numeric: "000" },
    name: "Original Eventuator",
    currency: "chf",
    common: false,
  },
];

export const currencies = [
  {
    id: "aed",
    code: { short: "د.إ", long: "aed", numeric: "784" },
    name: "Emirati Dirham",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "afn",
    code: { short: "؋", long: "afn", numeric: "971" },
    name: "Afghan Afghani",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "all",
    code: { short: "L", long: "all", numeric: "008" },
    name: "Albanian Lek",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "amd",
    code: { short: "֏", long: "amd", numeric: "051" },
    name: "Armenian Dram",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "ang",
    code: { short: "ƒ", long: "ang", numeric: "532" },
    name: "Netherlands Antillean Guilder",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "aoa",
    code: { short: "Kz", long: "aoa", numeric: "973" },
    name: "Angolan Kwanza",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "ars",
    code: { short: "$", long: "ars", numeric: "032" },
    name: "Argentine Peso",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "aud",
    code: { short: "$", long: "aud", numeric: "036" },
    name: "Australian Dollar",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "awg",
    code: { short: "ƒ", long: "awg", numeric: "533" },
    name: "Aruban Florin",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "azn",
    code: { short: "₼", long: "azn", numeric: "944" },
    name: "Azerbaijani Manat",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bam",
    code: { short: "KM", long: "bam", numeric: "977" },
    name: "Bosnia and Herzegovina Convertible Mark",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bbd",
    code: { short: "$", long: "bbd", numeric: "052" },
    name: "Barbados Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bdt",
    code: { short: "৳", long: "bdt", numeric: "050" },
    name: "Bangladeshi Taka",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bgn",
    code: { short: "лв", long: "bgn", numeric: "975" },
    name: "Bulgarian Lev",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bmd",
    code: { short: "BD$", long: "bmd", numeric: "060" },
    name: "Bermudian Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bnd",
    code: { short: "B$", long: "bnd", numeric: "096" },
    name: "Brunei Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bob",
    code: { short: "$b", long: "bob", numeric: "068" },
    name: "Boliviano",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "brl",
    code: { short: "R$", long: "brl", numeric: "986" },
    name: "Brazilian Real",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bsd",
    code: { short: "B$", long: "bsd", numeric: "044" },
    name: "Bahamian Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bwp",
    code: { short: "P", long: "bwp", numeric: "072" },
    name: "Botswana Pula",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "bzd",
    code: { short: "BZ$", long: "bzd", numeric: "084" },
    name: "Belize Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "cad",
    code: { short: "C$", long: "cad", numeric: "124" },
    name: "Canadian Dollar",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "cdf",
    code: { short: "CDF", long: "cdf", numeric: "976" },
    name: "Congolese Franc",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "chf",
    code: { short: "Fr.", long: "chf", numeric: "756" },
    name: "Swiss Franc",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "cny",
    code: { short: "¥", long: "cny", numeric: "156" },
    name: "Yuan Renminbi",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "cop",
    code: { short: "$", long: "cop", numeric: "170" },
    name: "Colombian Peso",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "crc",
    code: { short: "₡", long: "crc", numeric: "188" },
    name: "Costa Rican Colon",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "cve",
    code: { short: "Esc", long: "cve", numeric: "132" },
    name: "Cape Verdean Escudo",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "czk",
    code: { short: "Kč", long: "czk", numeric: "203" },
    name: "Czech Koruna",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "dkk",
    code: { short: "kr", long: "dkk", numeric: "208" },
    name: "Danish Krone",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "dop",
    code: { short: "RD$", long: "dop", numeric: "214" },
    name: "Dominican Peso",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "dzd",
    code: { short: "دج", long: "dzd", numeric: "012" },
    name: "Algerian Dinar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "egp",
    code: { short: "ج.م", long: "egp", numeric: "818" },
    name: "Egyptian Pound",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "etb",
    code: { short: "Br", long: "etb", numeric: "230" },
    name: "Ethiopian Birr",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "eur",
    code: { short: "€", long: "eur", numeric: "978" },
    name: "Euro",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "fjd",
    code: { short: "FJ$", long: "fjd", numeric: "242" },
    name: "Fiji Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "fkp",
    code: { short: "£", long: "fkp", numeric: "238" },
    name: "Falkland Islands Pound",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "gbp",
    code: { short: "£", long: "gbp", numeric: "826" },
    name: "Pound Sterling",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "gel",
    code: { short: "GEL", long: "gel", numeric: "981" },
    name: "Georgian Lari",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "gip",
    code: { short: "£", long: "gip", numeric: "292" },
    name: "Gibraltar Pound",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "gmd",
    code: { short: "D", long: "gmd", numeric: "270" },
    name: "Gambian Dalasi",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "gtq",
    code: { short: "Q", long: "gtq", numeric: "320" },
    name: "Guatemalan Quetzal",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "gyd",
    code: { short: "GY$", long: "gyd", numeric: "328" },
    name: "Guyanese Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "hkd",
    code: { short: "HK$", long: "hkd", numeric: "344" },
    name: "Hong Kong Dollar",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "hnl",
    code: { short: "L", long: "hnl", numeric: "340" },
    name: "Honduran Lempira",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "hrk",
    code: { short: "kn", long: "hrk", numeric: "191" },
    name: "Croatian Kuna",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "htg",
    code: { short: "HTG", long: "htg", numeric: "332" },
    name: "Haitian Gourde",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "huf",
    code: { short: "Ft", long: "huf", numeric: "348" },
    name: "Hungarian Forint",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "idr",
    code: { short: "Rp", long: "idr", numeric: "360" },
    name: "Indonesian Rupiah",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "ils",
    code: { short: "₪", long: "ils", numeric: "376" },
    name: "Israeli New Shekel",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "inr",
    code: { short: "Rs.", long: "inr", numeric: "356" },
    name: "Indian Rupee",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "isk",
    code: { short: "kr", long: "isk", numeric: "352" },
    name: "Icelandic Króna",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "jmd",
    code: { short: "J$", long: "jmd", numeric: "388" },
    name: "Jamaican Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "kes",
    code: { short: "KSh", long: "kes", numeric: "404" },
    name: "Kenyan Shilling",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "kgs",
    code: { short: "лв", long: "kgs", numeric: "417" },
    name: "Kyrgyzstani Som",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "khr",
    code: { short: "៛", long: "khr", numeric: "116" },
    name: "Cambodian Riel",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "kyd",
    code: { short: "$", long: "kyd", numeric: "136" },
    name: "Cayman Islands Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "kzt",
    code: { short: "лв", long: "kzt", numeric: "398" },
    name: "Kazakhstani Tenge",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "lak",
    code: { short: "₭", long: "lak", numeric: "418" },
    name: "Lao Kip",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "lbp",
    code: { short: "£", long: "lbp", numeric: "422" },
    name: "Lebanese Pound",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "lkr",
    code: { short: "₨", long: "lkr", numeric: "144" },
    name: "Sri Lankan Rupee",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "lrd",
    code: { short: "$", long: "lrd", numeric: "430" },
    name: "Liberian Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "lsl",
    code: { short: "LSL", long: "lsl", numeric: "426" },
    name: "Lesotho Loti",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mad",
    code: { short: "د.م.", long: "mad", numeric: "504" },
    name: "Moroccan Dirham",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mdl",
    code: { short: "MDL", long: "mdl", numeric: "498" },
    name: "Moldovan Leu",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mkd",
    code: { short: "ден", long: "mkd", numeric: "807" },
    name: "Macedonian Denar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mmk",
    code: { short: "K", long: "mmk", numeric: "104" },
    name: "Myanmar Kyat",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mnt",
    code: { short: "₮", long: "mnt", numeric: "496" },
    name: "Mongolian Tögrög",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mop",
    code: { short: "$", long: "mop", numeric: "446" },
    name: "Macanese Pataca",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mur",
    code: { short: "₨", long: "mur", numeric: "480" },
    name: "Mauritian Rupee",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mvr",
    code: { short: "Rf", long: "mvr", numeric: "462" },
    name: "Maldivian Rufiyaa",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mwk",
    code: { short: "MK", long: "mwk", numeric: "454" },
    name: "Malawian Kwacha",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mxn",
    code: { short: "$", long: "mxn", numeric: "484" },
    name: "Mexican Peso",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "myr",
    code: { short: "RM", long: "myr", numeric: "458" },
    name: "Malaysian Ringgit",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "mzn",
    code: { short: "MT", long: "mzn", numeric: "943" },
    name: "Mozambican Metical",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "nad",
    code: { short: "$", long: "nad", numeric: "516" },
    name: "Namibian Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "ngn",
    code: { short: "₦", long: "ngn", numeric: "566" },
    name: "Nigerian Naira",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "nio",
    code: { short: "C$", long: "nio", numeric: "558" },
    name: "Nicaraguan Córdoba",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "nok",
    code: { short: "kr", long: "nok", numeric: "578" },
    name: "Norwegian Krone",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "npr",
    code: { short: "₨", long: "npr", numeric: "524" },
    name: "Nepalese Rupee",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "nzd",
    code: { short: "$", long: "nzd", numeric: "554" },
    name: "New Zealand Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "pab",
    code: { short: "B/.", long: "pab", numeric: "590" },
    name: "Panamanian Balboa",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "pen",
    code: { short: "S/.", long: "pen", numeric: "604" },
    name: "Peruvian Sol",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "pgk",
    code: { short: "K", long: "pgk", numeric: "598" },
    name: "Papua New Guinean Kina",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "php",
    code: { short: "₱", long: "php", numeric: "608" },
    name: "Philippine Peso",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "pkr",
    code: { short: "₨", long: "pkr", numeric: "586" },
    name: "Pakistani Rupee",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "pln",
    code: { short: "zł", long: "pln", numeric: "985" },
    name: "Polish Złoty",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "qar",
    code: { short: "﷼", long: "qar", numeric: "634" },
    name: "Qatari Riyal",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "ron",
    code: { short: "L", long: "ron", numeric: "946" },
    name: "Romanian Leu",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "rsd",
    code: { short: "Дин.", long: "rsd", numeric: "941" },
    name: "Serbian Dinar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "rub",
    code: { short: "₽", long: "rub", numeric: "643" },
    name: "Russian Ruble",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "sar",
    code: { short: "﷼", long: "sar", numeric: "682" },
    name: "Saudi Riyal",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "sbd",
    code: { short: "$", long: "sbd", numeric: "090" },
    name: "Solomon Islands Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "scr",
    code: { short: "₨", long: "scr", numeric: "690" },
    name: "Seychelles Rupee",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "sek",
    code: { short: "kr", long: "sek", numeric: "752" },
    name: "Swedish Krona",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "sgd",
    code: { short: "$", long: "sgd", numeric: "702" },
    name: "Singapore Dollar",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "shp",
    code: { short: "£", long: "shp", numeric: "654" },
    name: "Saint Helena Pound",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "sll",
    code: { short: "SLL", long: "sll", numeric: "694" },
    name: "Sierra Leonean leone",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "sos",
    code: { short: "S", long: "sos", numeric: "706" },
    name: "Somali Shilling",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "srd",
    code: { short: "$", long: "srd", numeric: "968" },
    name: "Surinamese Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "szl",
    code: { short: "SZL", long: "szl", numeric: "748" },
    name: "Swazi Lilangeni",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "thb",
    code: { short: "฿", long: "thb", numeric: "764" },
    name: "Thai Baht",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "tjs",
    code: { short: "TJS", long: "tjs", numeric: "972" },
    name: "Tajikistani Somoni",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "top",
    code: { short: "T$", long: "top", numeric: "776" },
    name: "Tongan Pa'anga",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "try",
    code: { short: "YTL", long: "try", numeric: "949" },
    name: "Turkish Lira",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "ttd",
    code: { short: "TT$", long: "ttd", numeric: "780" },
    name: "Trinidad and Tobago Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "twd",
    code: { short: "NT$", long: "twd", numeric: "901" },
    name: "New Taiwan Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "tzs",
    code: { short: "x", long: "tzs", numeric: "834" },
    name: "Tanzanian Shilling",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "uah",
    code: { short: "₴", long: "uah", numeric: "980" },
    name: "Ukrainian Hryvnia",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "usd",
    code: { short: "$", long: "usd", numeric: "840" },
    name: "United States Dollar",
    decimal: true,
    accepted: true,
    common: true,
  },
  {
    id: "uyu",
    code: { short: "$U", long: "uyu", numeric: "858" },
    name: "Uruguayan Peso",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "uzs",
    code: { short: "лв", long: "uzs", numeric: "860" },
    name: "Uzbekistan Som",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "wst",
    code: { short: "WS$", long: "wst", numeric: "882" },
    name: "Samoan Tala",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "xcd",
    code: { short: "EC$", long: "xcd", numeric: "951" },
    name: "East Caribbean Dollar",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "zar",
    code: { short: "R", long: "zar", numeric: "710" },
    name: "South African Rand",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "zmw",
    code: { short: "ZMW", long: "zmw", numeric: "967" },
    name: "Zambian Kwacha",
    decimal: true,
    accepted: true,
    common: false,
  },
  {
    id: "yer",
    code: { short: "﷼", long: "yer", numeric: "886" },
    name: "Yemeni Rial",
    decimal: true,
    accepted: true,
    common: false,
  },
  // not accepted
  {
    id: "bhd",
    code: { short: ".د.ب", long: "bhd", numeric: "048" },
    name: "Bahraini Dinar",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "bif",
    code: { short: "Fbu", long: "bif", numeric: "108" },
    name: "Burundian Franc",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "bov",
    code: { short: "BOV", long: "bov", numeric: "984" },
    name: "Bolivian Mvdol",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "btn",
    code: { short: "Nu.", long: "btn", numeric: "064" },
    name: "Bhutanese Ngultrum",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "byn",
    code: { short: "Br", long: "byn", numeric: "933" },
    name: "Belarusian Ruble",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "che",
    code: { short: "CHE", long: "che", numeric: "947" },
    name: "WIR Euro",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "chw",
    code: { short: "CHW", long: "chw", numeric: "948" },
    name: "WIR Franc",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "clf",
    code: { short: "CLF", long: "clf", numeric: "990" },
    name: "Unidad de Fomento",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "clp",
    code: { short: "$", long: "clp", numeric: "152" },
    name: "Chilean Peso",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "cou",
    code: { short: "COU", long: "cou", numeric: "970" },
    name: "Unidad de Valor Real",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "cuc",
    code: { short: "CUC", long: "cuc", numeric: "931" },
    name: "Cuban Convertible Peso",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "cup",
    code: { short: "₱", long: "cup", numeric: "192" },
    name: "Cuban Peso",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "djf",
    code: { short: "Fdj", long: "djf", numeric: "262" },
    name: "Djiboutian Franc",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "ern",
    code: { short: "ERN", long: "ern", numeric: "232" },
    name: "Eritrean Nakfa",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "ghs",
    code: { short: "¢", long: "ghs", numeric: "936" },
    name: "Ghanaian Cedi",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "gnf",
    code: { short: "FG", long: "gnf", numeric: "324" },
    name: "Guinean Franc",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "iqd",
    code: { short: "ع.د", long: "iqd", numeric: "368" },
    name: "Iraqi Dinar",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "irr",
    code: { short: "﷼", long: "irr", numeric: "364" },
    name: "Iranian Rial",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "jod",
    code: { short: "JOD", long: "jod", numeric: "400" },
    name: "Jordanian Dinar",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "jpy",
    code: { short: "¥", long: "jpy", numeric: "392" },
    name: "Japanese Yen",
    decimal: false,
    accepted: false,
    common: true,
  },
  {
    id: "kmf",
    code: { short: "KMF", long: "kmf", numeric: "174" },
    name: "Comoro Franc",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "kpw",
    code: { short: "₩", long: "kpw", numeric: "408" },
    name: "North Korean Won",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "krw",
    code: { short: "₩", long: "krw", numeric: "410" },
    name: "South Korean Won",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "kwd",
    code: { short: "د.ك", long: "kwd", numeric: "414" },
    name: "Kuwaiti Dinar",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "lyd",
    code: { short: "LYD", long: "lyd", numeric: "434" },
    name: "Libyan Dinar",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "mga",
    code: { short: "MGA", long: "mga", numeric: "969" },
    name: "Malagasy Ariary",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "mru",
    code: { short: "MRU", long: "mru", numeric: "929" },
    name: "Mauritanian Ouguiya",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "mxv",
    code: { short: "MXV", long: "mxv", numeric: "979" },
    name: "Mexican Unidad de Inversion",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "omr",
    code: { short: "﷼", long: "omr", numeric: "512" },
    name: "Omani Rial",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "pyg",
    code: { short: "Gs", long: "pyg", numeric: "600" },
    name: "Paraguayan Guaraní",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "rwf",
    code: { short: "RF", long: "rwf", numeric: "646" },
    name: "Rwandan Franc",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "sdg",
    code: { short: "SDG", long: "sdg", numeric: "938" },
    name: "Sudanese Pound",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "ssp",
    code: { short: "SSP", long: "ssp", numeric: "728" },
    name: "South Sudanese Pound",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "stn",
    code: { short: "STN", long: "stn", numeric: "930" },
    name: "São Tomé and Príncipe Dobra",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "svc",
    code: { short: "$", long: "svc", numeric: "222" },
    name: "Salvadoran Colón",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "syp",
    code: { short: "£", long: "syp", numeric: "760" },
    name: "Syrian Pound",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "tmt",
    code: { short: "TMT", long: "tmt", numeric: "934" },
    name: "Turkmenistan Manat",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "tnd",
    code: { short: "د.ت", long: "tnd", numeric: "788" },
    name: "Tunisian Dinar",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "ugx",
    code: { short: "USh", long: "ugx", numeric: "800" },
    name: "Ugandan Shilling",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "usn",
    code: { short: "USN", long: "usn", numeric: "997" },
    name: "United States Dollar Next Day",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "uyi",
    code: { short: "UYI", long: "uyi", numeric: "940" },
    name: "Uruguay Peso en Unidades Indexadas",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "uyw",
    code: { short: "UYW", long: "uyw", numeric: "927" },
    name: "Unidad Previsional",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "vef",
    code: { short: "Bs", long: "vef", numeric: "937" },
    name: "Bolivar",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "ves",
    code: { short: "VES", long: "ves", numeric: "928" },
    name: "Venezuelan Bolívar Soberano",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "vnd",
    code: { short: "₫", long: "vnd", numeric: "704" },
    name: "Vietnamese Đồng",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "vuv",
    code: { short: "Vt", long: "vuv", numeric: "548" },
    name: "Vanuatu Vatu",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xaf",
    code: { short: "BEAC", long: "xaf", numeric: "950" },
    name: "CFA Franc BEAC",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xag",
    code: { short: "XAG", long: "xag", numeric: "961" },
    name: "Silver",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xau",
    code: { short: "XAU", long: "xau", numeric: "959" },
    name: "Gold",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xba",
    code: { short: "XBA", long: "xba", numeric: "955" },
    name: "European Composite Unit",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xbb",
    code: { short: "XBB", long: "xbb", numeric: "956" },
    name: "European Monetary Unit",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xbc",
    code: { short: "XBC", long: "xbc", numeric: "957" },
    name: "European Unit of Account 9",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xbd",
    code: { short: "XBD", long: "xbd", numeric: "958" },
    name: "European Unit of Account 17",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xdr",
    code: { short: "XDR", long: "xdr", numeric: "960" },
    name: "Special Drawing Rights",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xof",
    code: { short: "BCEAO", long: "xof", numeric: "952" },
    name: "CFA Franc BCEAO",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xpd",
    code: { short: "XPD", long: "xpd", numeric: "964" },
    name: "Palladium",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xpf",
    code: { short: "F", long: "xpf", numeric: "953" },
    name: "CFP Franc",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xpt",
    code: { short: "XPT", long: "xpt", numeric: "962" },
    name: "Platinum",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xsu",
    code: { short: "XSU", long: "xsu", numeric: "994" },
    name: "SUCRE",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xts",
    code: { short: "XTS", long: "xts", numeric: "963" },
    name: "Code Reserved for Testing",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xua",
    code: { short: "XUA", long: "xua", numeric: "965" },
    name: "ADB Unit of Account",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "xxx",
    code: { short: "XXX", long: "xxx", numeric: "999" },
    name: "No Currency",
    decimal: false,
    accepted: false,
    common: false,
  },
  {
    id: "zwl",
    code: { short: "ZWL", long: "zwl", numeric: "932" },
    name: "Zimbabwean Dollar",
    decimal: false,
    accepted: false,
    common: false,
  },
];
